//const apiBaseUrl = "http://20.164.36.185:4000";
export const apiBaseUrl = "https://lesotho.southafricanorth.cloudapp.azure.com/api2";

async function safeFetch(url) {
  const res = await fetch(url);
  // if (!res.ok) throw new Error(`HTTP ${res.status} - ${res.statusText}`);
  const contentType = res.headers.get("content-type");

  if (contentType && contentType.includes("application/json")) {
    return res.json(); // safely parse JSON
  }
  return null
}

export async function fetchEvents() {
  return safeFetch(`${apiBaseUrl}/api/results/events`);
}

export async function fetchDistricts(eventID) {
  // endpoint doesn't require eventID in original server, but passed for future-proofing
  return safeFetch(`${apiBaseUrl}/api/results/delimitation/national/districts`);
}

export async function fetchConstituencies(districtID) {
  return safeFetch(`${apiBaseUrl}/api/results/delimitation/national/constituencies/district/${districtID}`);
}

export async function fetchPollingDivisions(constituencyID) {
  return safeFetch(`${apiBaseUrl}/api/results/delimitation/national/pollingdivisions/constituency/${constituencyID}`);
}

export async function fetchRegistrationCentres(pollingDivisionID) {
  return safeFetch(`${apiBaseUrl}/api/results/delimitation/national/registrationcentres/pollingdivision/${pollingDivisionID}`);
}

export async function fetchPollingStations(registrationCentreID) {
  return safeFetch(`${apiBaseUrl}/api/results/delimitation/national/pollingstations/${registrationCentreID}`);
}

export async function fetchElectionResults(eventID, delimitationLevelID, delimitationID) {
  return safeFetch(`${apiBaseUrl}/api/results/dashboard?eventID=${eventID}&delimitationLevelID=${delimitationLevelID}&delimitationID=${delimitationID}`);
}
